import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import StoreContext from '../../react-core-lib/components/app/store-context';
import HandoutContent from './handout-content';
import ErrorMessage from './error-message';
import UserApi from '../../rest-api/user-api';
import PartnerApi from '../../rest-api/partner-api';

const ContentLoader = () => {
    const appStateStore = useContext(StoreContext);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [linkId, setLinkId] = useState(null);
    const [clinicData, setClinicData] = useState(null); // Use state for storing clinic image URL, clinic name and account type
    const [show3DModel, setShow3DModel] = useState(true);
    const [showMainIllustration, setShowMainIllustration] = useState(true);
    const [showTutorialVideo, setShowTutorialVideo] = useState(true);

    // Function to validate UUID
    const validateUUID = (uuid) => {
        const regex = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
        return regex.test(uuid);
    };

    useEffect(() => {
        const fetchClinicData = async (clinicId) => {
            try {
                const clinicData = await UserApi.getClinicianImage(clinicId);
                if (clinicData) {
                    console.warn('clinicData obtained:', clinicData);
                    setClinicData({
                        ...clinicData,
                        source: 'platform',
                    });
                }
            } catch (error) {
                console.error('Error fetching clinic image:', error);
            }
        };

        const initializeContent = async () => {
            console.warn('==== initializeContent ====');
            setLoading(true);
            await appStateStore.initializeUserStoresAsync('PatientUI');

            const urlParams = new URLSearchParams(window.location.search);
            const potentialLinkId = urlParams.get('linkId');
            const clinicId = urlParams.get('clinicId');
            const isPartnerLink = !!(potentialLinkId && !clinicId);

            // Toggle parameters
            const show3DModelParam = urlParams.get('show3DModel');
            const showMainIllustrationParam = urlParams.get('showMainIllustration');
            const showTutorialVideoParam = urlParams.get('showTutorialVideo');

            // Set toggle states, default is true (if not specified)
            setShow3DModel(show3DModelParam !== 'false');
            setShowMainIllustration(showMainIllustrationParam !== 'false');
            setShowTutorialVideo(showTutorialVideoParam !== 'false');

            if (clinicId) {
                await fetchClinicData(clinicId);
            }

            if (potentialLinkId && validateUUID(potentialLinkId)) {
                setLinkId(potentialLinkId);

                if (isPartnerLink) {
                    try {
                        const response = await PartnerApi.getPublicClinicData(potentialLinkId);
                        if (response?.clinicData) {
                            console.warn('Fetched partner clinic data:', response.clinicData);
                            setClinicData({
                                ...response.clinicData,
                                source: 'partner',
                            });
                        }
                    } catch (e) {
                        console.warn(
                            'LinkId is valid but public-clinic-data not found or expired. Proceeding without logo.',
                        );
                    }
                }
            } else {
                setError(`Invalid link ID: ${potentialLinkId}`);
            }

            setLoading(false);
        };

        initializeContent();
    }, [appStateStore]); // seems it was missing

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <ErrorMessage message={error} />;
    }

    // Pass the toggle states as props
    return (
        <HandoutContent
            linkId={linkId}
            clinicData={clinicData}
            show3DModel={show3DModel}
            showMainIllustration={showMainIllustration}
            showTutorialVideo={showTutorialVideo}
        />
    );
};

export default ContentLoader;
